<template>
  <div class="tw:flex tw:flex-row tw:w-screen tw:h-screen">
    <div class="tw:relative tw:flex tw:flex-col tw:justify-start tw:gap-12 tw:bg-background tw:border-r tw:p-10 tw:w-[420px] tw:max-w-full tw:flex-none tw:overflow-y-auto">
      <slot />
    </div>
    <div class="tw:relative tw:flex-3 tw:hidden tw:lg:flex tw:items-center tw:justify-center" :style="coverStyle">
      <InlineSvg v-if="!cover" :src="voompLogo" width="16rem" height="16rem" />
      <img
        v-if="logo"
        :src="logo"
        alt="logo"
        class="tw:absolute tw:bottom-10 tw:right-10 tw:max-h-16 tw:object-contain"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import InlineSvg from 'vue-inline-svg';
import voompLogo from '@/assets/icons/voomp.svg';
import { computed } from 'vue';

const props = defineProps<{
  cover?: string;
  logo?: string;
}>();

const coverStyle = computed(() => {
  return {
    backgroundColor: '#F58220',
    backgroundImage: `url(${props.cover})`,
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  };
});

</script>
